<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" color="#FFFF99">
                        <v-card-title>
                            <v-icon large left>mdi-files</v-icon>
                            Recuperar Remitos de Entrega Documentación
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-card-title>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headers" :items="listado" :single-expand="true" locale="es-ar"
                                class="elevation-1" :items-per-page="200000" hide-default-footer :loading="loadtable"
                                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                                <template v-slot:item.seleccionar="{ item }">
                                    <v-checkbox v-model="item.seleccionar" dense hide-details
                                        class="mini-check"></v-checkbox>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card color="orange" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="recuperar" :disabled="deshabilitar">Recuperar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<style scoped>
.font-class-name {
    font-size: 12px;
}

/* Texto general dentro de la tabla */
.v-data-table td {
    font-size: 12px;
    padding: 4px 8px !important;
}

/* Checkbox */
.mini-check .v-icon {
    font-size: 12px !important;
}

.mini-check .v-input--selection-controls__ripple {
    width: 0;
    height: 0;
}

/* Radios */
.mini-radio-group .v-icon {
    font-size: 12px !important;
}

.mini-radio-group .v-label {
    font-size: 11px;
}

/* Elimina espacios extra */
.mini-radio-group .v-input--selection-controls__input {
    margin-right: 4px;
}

.compact-table .v-input {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}
</style>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
export default {
    props: ["visible"],
    data() {
        return {
            lazy: false,
            valid: false,
            deshabilitar: false,
            loadtable: false,
            listado: [],
            listadofiltrado: [],
            headers: [
                { text: "Seleccionar", value: "seleccionar", width: "5%", sortable: false },
                {
                    text: "N° Remito",
                    align: "start",
                    sortable: false,
                    value: "remito",
                },
                { text: "N° Cliente", value: "numcliente", sortable: false },
                { text: "Cliente", value: "nomcliente", sortable: false },
                { text: "N° Obra", value: "numobra", sortable: false },
                { text: "Obra", value: "nomobra", sortable: false },
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Responsable", value: "responsable", sortable: false },
            ],

        };
    },

    computed: {
        show: {
            get() {
                //this.mostrar = true;
                //this.elaboro = this.$store.state.nombre.toString().trim();
                if (this.visible == true) {
                    this.listadorecuperar();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            const initialState = this.$options.data.call(this);

            Object.keys(initialState).forEach((key) => {
                this[key] = initialState[key];
            });
        },
        listadorecuperar() {
            let self = this;
            axios
                .get("/Ingenieria/RecuperarRemitoListado?")
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
        recuperar() {

            this.listadofiltrado = [];
            this.$swal({
                title: "Guardar Remito",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    this.listado.forEach((element) => {
                        if (element.seleccionar == true) {

                            this.listadofiltrado.push({
                                remito: element.remito,
                                numcliente: element.numcliente,
                                numobra: element.numobra,

                            });
                        }
                    });
                    axios

                        .post("/Ingenieria/RecuperarRemito", this.listadofiltrado)
                        .then(() => {
                            this.showAlert({
                                icon: "success",
                                title: "Remito recuperado con éxito",
                                vm: this,
                            });

                            this.vaciarModels();
                            this.$emit("close"); // o this.$emit("guardado")
                        })
                        .catch((error) => {
                            console.log(error);

                            this.showAlert({
                                icon: "error",
                                title: "Error al guardar",
                                vm: this,
                            });
                        })
                        .finally(() => {
                            this.deshabilitar = false;
                        });
                }
            });

        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
